import { render } from "./History.vue?vue&type=template&id=0896fa47&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"

import "./History.vue?vue&type=style&index=0&id=0896fa47&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0896fa47"]])

export default __exports__